import React, { useEffect } from 'react'
import IntlProvider from 'react-intl/lib/src/components/provider'
import { createIntl } from 'react-intl'
import { setGState } from '../utils/controllers/GlobalStateController'
import { intlConfig } from '../utils/consts/intlConfig'

const SatIntlProvider = ({ children }) => {
  useEffect(() => {
    let intl = createIntl(intlConfig)
    setGState('intl', intl)
  })

  return <IntlProvider {...intlConfig}>{children}</IntlProvider>
}

export default SatIntlProvider
